
import { mapGetters } from 'vuex'
import { header, image, footer, seo, redes } from '../../customWhiteLabel'
export default {
  data() {
    return {
      header,
      image,
      footer,
      seo,
      redes,
    }
  },
  computed: {
    ...mapGetters('unidade', ['unidadeInformation']),
    DNPsafeweb() {
      if (this.unidadeInformation.unidade === 'senhadigitalplus.com.br') {
        return true
      } else {
        return false
      }
    },
  },
  methods: {
    redirectToPrivacyPolicy() {
      this.$router.push('/politicas')
    },
    redirectDPN() {
      this.$router.push('/dpn')
    },
    redirectDPNCD() {
      this.$router.push('/dpn-cd')
    },
    redirectDPNRFB() {
      this.$router.push('/dpn-rfb')
    },
  },
}
